<template>
  <div class="wrapper">
    <div>
    <CButton v-if="permission" color="info" @click="openModal"><b>Add New Kids</b></CButton>
    <CRow class="mt-3">
      <div>  
      </div>
      <CCol sm="12">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            :btn_show="true"
                            :btn_edit="true"
                            :btn_deactivate="true"
                            :btn_reactivate="true"
                            :btn_delete="false"
                            :is_uuid="true"
                            @show="handleShow"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                        />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
      <ikidmodal></ikidmodal>
      <alertmodal></alertmodal>
    </div>
  </div>
</template>

<script>
import Datatable from '@/components/datatables_ikid.vue'
import axios from 'axios'

import ikid from '@/services/ikid'
import ikidmodal from './ikidsmodal.vue';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'

const token = localStorage.getItem('token');

export default {
  name: 'iKidsTable',
  components: { ikidmodal, alertmodal, Datatable },
  data(){
    return{
      form:{
        name:'',
      },
      updateSubmit: false,
      largeModal:false,
      datas:[], 


      //start
      fields: [
          {key: 'name', sortable: false, },
          {key: 'class_name', sortable: false, },
          {key: 'dob', sortable: false, },
          {key: 'is_active', sortable: false},
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
      permission: true,
      //end
    }
  },

  created() {
      //this.loadData()
      this.beforeDestroy()
  },
  
  mounted (){
     this.loadData()

    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();  
      }
    });

   },
   
  methods: {
     beforeDestroy(){
    EventBus.$off('OPEN_MODAL_IKID_NOTE', this.listener)
    EventBus.$off('OPEN_MODAL_IKID', this.listener)
    console.log('OFF_OPEN_MODAL_IKID')
   },
    openModal: function () {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit kid (including edit class/parents/etc)') !== -1){
          //IF ALLOW
          var params = {title: 'Add New Kid', mode:'create'}
          EventBus.$emit('OPEN_MODAL_IKID', params)
          //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal')
        } 
        
      }
      //SET END
    },

   
    openShow(id){
        // var params = {title: 'Show Necessary', mode:'edit', data:id}
        // EventBus.$emit('OPEN_DETAIL_IKID', params)
        
        this.$router.push({name:'Detail Kids',query: {id:id} }) 
        console.log(' open show detail')
    },

    openModalEdit(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit kid (including edit class/parents/etc)') !== -1){
          //IF ALLOW
          var params = {title: 'Edit Kid', mode:'edit', data:id}
          EventBus.$emit('OPEN_MODAL_IKID', params)
          //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },

    deactivate(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Reactivate/deactivate kid') !== -1){
          //IF ALLOW
          if(confirm("Do you really want to deactivate?")){
            ikid.deactivateIkid(id)
            .then(res => {
              EventBus.$emit('TABLE_UPDATE', true)
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
          }  
          //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    reactivate(id){

      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Reactivate/deactivate kid') !== -1){
          //IF ALLOW
          if(confirm("Do you really want to reactivate?")){
            ikid.reactivateIkid(id)
            .then(res => {
              EventBus.$emit('TABLE_UPDATE', true)
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
          }
          //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        //headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }

      ikid.getIkidDataSource(params)
      .then(res => {
         
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
              
          }
          
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
         
    },
    
    handlePagination(val) {
        this.current_page = val 
        
        this.loadData()
        
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
        
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)
    },

  }
}
</script>